import { useForm } from "react-hook-form";
import PageTitle from "../../layouts/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { ContextApi } from "../../../store/ContextApi";
import { useContext } from "react";
import { getCouponsFunc } from "../../../store/custom-actions/coupons-actions/GetCouponsSlicer";
import { toast } from "react-toastify";
import { addCouponFunc } from "../../../store/custom-actions/coupons-actions/AddCouponSlicer";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NewCouponForm() {
    const {t} = useTranslation();
    const {register , reset , formState : {errors} , handleSubmit} = useForm();
    const {loading:addCouponLoading} = useSelector(state => state.addCouponSlicer);
    const contextApi = useContext(ContextApi);
    const coupons_API_URL = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/coupons`;
    const dispatch = useDispatch();
    const nivigate = useNavigate();
    const handleSubmitData = (data) => {
        if(data.start_date > data.end_date) {
            toast.error(t(`End date must be more than start date`), {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            })
        }else {
            dispatch(addCouponFunc({api : coupons_API_URL , data : {...data}}))
            .then(result => {
                if(result.payload.success === true) {
                  const successMessage = result.payload.message;
                  dispatch(getCouponsFunc(coupons_API_URL));
                  reset();
                  nivigate("/coupons");
                  toast.success(`${t(successMessage)}!`, {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                  })
              }
          })
        }
    }
    // return (
    //     <>
    //         <PageTitle motherMenu={"Dashboard"} activeMenu={"New Coupon"} />
    //         <div className="col-12">
    //             <div className="card">
    //                 <div className="card-body">
    //                     <form
    //                         id="new-coupon-form"
    //                         onSubmit={handleSubmit((data) => {
    //                             handleSubmitData(data)
    //                         })}
    //                     >
    //                         <div className='row'>
    //                             <div className="form-group mb-3 col-sm-12 col-md-6">
    //                                 <label>Code</label>
    //                                 {errors.code?.message && (
    //                                 <p className="text-red-600">{errors.code?.message}</p>
    //                                 )}
    //                                 <input
                                    
    //                                 {...register("code" , {required : "Code should not be empty!"})}
    //                                 type="text"
    //                                 className="form-control"
    //                                 />
    //                             </div>
    //                             <div className="form-group mb-3 col-sm-12 col-md-6">
    //                                 <label>Discount</label>
    //                                 {errors.discount?.message && (
    //                                 <p className="text-red-600">{errors.discount?.message}</p>
    //                                 )}
    //                                 <input
                                    
    //                                 {...register("discount" , {required : "Discount should not be empty!"})}
    //                                 type="number"
    //                                 min={0}
    //                                 className="form-control"
    //                                 />
    //                             </div>
    //                         </div>
    //                         <div className='row'>
    //                             <div className="form-group mb-3 col-sm-12 col-md-6">
    //                                 <label>Usage Limit</label>
    //                                 {errors.count_used?.message && (
    //                                 <p className="text-red-600">{errors.count_used?.message}</p>
    //                                 )}
    //                                 <input
                                    
    //                                 {...register("count_used" , {required : "Usage limit should not be empty!"})}
    //                                 type="number"
    //                                 min={0}
    //                                 className="form-control"
    //                                 />
    //                             </div>
    //                             <div
    //                                 className={`form-group mb-3 col-sm-12 col-md-6`}
    //                             >
    //                                 <label>Discount Type</label>
    //                                 {errors.type?.message && (
    //                                 <p className="text-red-600">{errors.type?.message}</p>
    //                                 )}
    //                                 <select
    //                                     className={`form-control col-sm-12`}
    //                                     {...register("type" , {required : "Discount Type limit should not be empty!"})}
    //                                 >
    //                                     <option value={"fixed"}>Fixed</option>
    //                                     <option value={"percentage"}>Percentage</option>
    //                                 </select>
    //                             </div>
    //                         </div>
    //                         <div className='row'>
    //                             <div className="form-group mb-3 col-sm-12 col-md-6">
    //                                 <label>From :</label>
    //                                 {errors.start_date?.message && (
    //                                 <p className="text-red-600">{errors.start_date?.message}</p>
    //                                 )}
    //                                 <input
                                    
    //                                 {...register("start_date" , {required : "Start Date should not be empty!"})}
    //                                 type="date"
    //                                 className="form-control"
    //                                 />
    //                             </div>
    //                             <div className="form-group mb-3 col-sm-12 col-md-6">
    //                                 <label>To :</label>
    //                                 {errors.end_date?.message && (
    //                                 <p className="text-red-600">{errors.end_date?.message}</p>
    //                                 )}
    //                                 <input
                                    
    //                                 {...register("end_date" , {required : "End Date should not be empty!"})}
    //                                 type="date"
    //                                 className="form-control"
    //                                 />
    //                             </div>
    //                         </div>
    //                         <div className='row'>
    //                             <Button type="submit" form="new-coupon-form" className={` form-control ${addCouponLoading ? "opacity-80 pointer-events-none" : ""} w-fit`} style={{width : "fit-content"}}>
    //                                 {!addCouponLoading ? (
    //                                 "Submit"
    //                                 ) : (
    //                                 <>
    //                                     <div className="relative flex justify-center items-center">
    //                                     loading..
    //                                     </div>
    //                                 </>
    //                                 )}
    //                             </Button>
    //                         </div>
    //                     </form>
    //                 </div>
    //             </div>
    //         </div> 
    //     </>
    // )

    return (
        <>
          <PageTitle motherMenu={t("Dashboard")} activeMenu={t("New Coupon")} />
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <form
                  id="new-coupon-form"
                  onSubmit={handleSubmit((data) => {
                    handleSubmitData(data);
                  })}
                >
                  <div className="row">
                    <div className="form-group mb-3 col-sm-12 col-md-6">
                      <label>{t("Code")}</label>
                      {errors.code?.message && (
                        <p className="text-red-600">{t(errors.code?.message)}</p>
                      )}
                      <input
                        {...register("code", { required: t("Feild is required") })}
                        type="text"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group mb-3 col-sm-12 col-md-6">
                      <label>{t("Discount")}</label>
                      {errors.discount?.message && (
                        <p className="text-red-600">{t(errors.discount?.message)}</p>
                      )}
                      <input
                        {...register("discount", { required: t("Feild is required") })}
                        type="number"
                        min={0}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group mb-3 col-sm-12 col-md-6">
                      <label>{t("Usage limit")}</label>
                      {errors.count_used?.message && (
                        <p className="text-red-600">{t(errors.count_used?.message)}</p>
                      )}
                      <input
                        {...register("count_used", { required: t("Feild is required") })}
                        type="number"
                        min={0}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group mb-3 col-sm-12 col-md-6">
                      <label>{t("Discount type")}</label>
                      {errors.type?.message && (
                        <p className="text-red-600">{t(errors.type?.message)}</p>
                      )}
                      <select
                        className="form-control col-sm-12"
                        {...register("type", { required: t("Feild is required") })}
                      >
                        <option value="fixed">{t("Fixed")}</option>
                        <option value="percentage">{t("Percentage")}</option>
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group mb-3 col-sm-12 col-md-6">
                      <label>{t("From")}:</label>
                      {errors.start_date?.message && (
                        <p className="text-red-600">{t(errors.start_date?.message)}</p>
                      )}
                      <input
                        {...register("start_date", { required: t("Feild is required") })}
                        type="date"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group mb-3 col-sm-12 col-md-6">
                      <label>{t("To")}:</label>
                      {errors.end_date?.message && (
                        <p className="text-red-600">{t(errors.end_date?.message)}</p>
                      )}
                      <input
                        {...register("end_date", { required: t("Feild is required") })}
                        type="date"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <Button
                      type="submit"
                      form="new-coupon-form"
                      className={`form-control ${
                        addCouponLoading ? "opacity-80 pointer-events-none" : ""
                      } w-fit`}
                      style={{ width: "fit-content" }}
                    >
                      {!addCouponLoading ? (
                        t("Submit")
                      ) : (
                        <div className="relative flex justify-center items-center">{t("Loading")}...</div>
                      )}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      );

}